export const ResourceProtocols = ['http'] as const;
export type ResourceProtocol = (typeof ResourceProtocols)[number];

export const HttpMethods = ['GET', 'POST', 'PUT', 'DELETE', 'PATCH', 'HEAD', 'OPTIONS'] as const;
export type HttpMethod = (typeof HttpMethods)[number];

export type Resource = {
  id?: string;
  protocol: ResourceProtocol;
  method: HttpMethod;
  path: string;
};
